import React from 'react';
import NavBar from './Navbar/Navbar';
import Footer from './Footer/Footer';
import ScrollToTop from './ScrollToTop';

const Layout = ({ children }) => {
    return (
        <div className="layout-wrapper">
            <ScrollToTop />
            <NavBar />
            <main className="layout-content">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
